import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TopupServiceService } from '../Services/topup-service.service';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { CookieService } from '../Services/cookie';
import { CardServiceService } from '../Services/card-service.service';

@Component({
  selector: 'app-payment-successful',
  templateUrl: './payment-successful.component.html',
  standalone:false,
  styleUrls: ['./payment-successful.component.scss']
})
export class PaymentSuccessfulComponent implements OnInit {

  constructor(private cookieService: CookieService, private route: ActivatedRoute, public datepipe: DatePipe, public topup: TopupServiceService, private _router: Router, private auth: AuthService, private commonP: CommonService, private topupservice: TopupServiceService, private cardService: CardServiceService) { }
 


  async ngOnInit(): Promise<any> {


  }

}
